/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Avoid_Real_WordsInputs */



/**
* | output |
* | --- |
* | "Avoid the use of real words or abbreviations. They will automatically be replaced." |
*
* @param {Avoid_Real_WordsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const avoid_real_words = /** @type {((inputs?: Avoid_Real_WordsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Avoid_Real_WordsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Évitez l'utilisation de mots réels ou d'abréviations. Ils seront automatiquement remplacés.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte verwenden Sie keine echten Wörter oder Abkürzungen. Diese werden automatisch ersetzt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Evitate l'uso di parole reali o abbreviazioni. Verranno automaticamente sostituite.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Избегайте использования настоящих слов или сокращений. Они будут автоматически заменены.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Evite usar palabras reales o abreviaturas. Se reemplazarán automáticamente.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("避免使用真实单词或缩写。它们将被自动替换。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("実在の単語や略語の使用は避けてください。それらは自動的に置き換えられます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वास्तविक शब्दों या संक्षिप्ताक्षरों का प्रयोग करने से बचें। इन्हें स्वचालित रूप से बदल दिया जाएगा।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Evite o uso de palavras reais ou abreviações. Elas serão substituídas automaticamente.")
	return /** @type {LocalizedString} */ ("Avoid the use of real words or abbreviations. They will automatically be replaced.")
});